var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 10.8984C11.8594 10.6875 11.8594 10.3359 11.6484 10.1016L7.71094 6.16406C7.33594 5.8125 6.75 6.07031 6.75 6.5625V8.8125H3.5625C3.23438 8.8125 3 9.07031 3 9.375V11.625C3 11.9531 3.23438 12.1875 3.5625 12.1875H6.75V14.4375C6.75 14.9531 7.35938 15.1875 7.71094 14.8359L11.6484 10.8984ZM4.5 14.7188V13.7812C4.5 13.6406 4.35938 13.5 4.21875 13.5H2.25C1.82812 13.5 1.5 13.1719 1.5 12.75V8.25C1.5 7.85156 1.82812 7.5 2.25 7.5H4.21875C4.35938 7.5 4.5 7.38281 4.5 7.21875V6.28125C4.5 6.14062 4.35938 6 4.21875 6H2.25C1.00781 6 0 7.00781 0 8.25V12.75C0 13.9922 1.00781 15 2.25 15H4.21875C4.35938 15 4.5 14.8828 4.5 14.7188Z",
    fill: "#025652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutArrow);
export default __webpack_public_path__ + "static/media/LogoutArrow.9e7c8bb8.svg";
export { ForwardRef as ReactComponent };